/** Configuración global de la aplicación (textos y valores fijos). */
export const config = {
  appName: "Bombastic",
  tagline: "Producto, BOMs y compras",
  companyName: "Accent Systems",
} as const;
